module.exports = __webpack_public_path__ + "img/document-download-border.196699f8.svg";